/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BaselineAssessmentRun } from './BaselineAssessmentRun';
import {
    BaselineAssessmentRunFromJSON,
    BaselineAssessmentRunFromJSONTyped,
    BaselineAssessmentRunToJSON,
    BaselineAssessmentRunToJSONTyped,
} from './BaselineAssessmentRun';
import type { AssetBaselineMapping } from './AssetBaselineMapping';
import {
    AssetBaselineMappingFromJSON,
    AssetBaselineMappingFromJSONTyped,
    AssetBaselineMappingToJSON,
    AssetBaselineMappingToJSONTyped,
} from './AssetBaselineMapping';

/**
 * 
 * @export
 * @interface BaselineEntity
 */
export interface BaselineEntity {
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    status?: BaselineEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BaselineEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BaselineEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    baselineVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineEntity
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    oscalProfileRef?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    oscalComponentDefRef?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    baselineSource?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaselineEntity
     */
    applicableAssetTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaselineEntity
     */
    applicableOsFamilies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaselineEntity
     */
    applicableCloudProviders?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BaselineEntity
     */
    scopeCriteria?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    framework?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineEntity
     */
    complianceLevel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineEntity
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineEntity
     */
    isDefault?: boolean;
    /**
     * 
     * @type {Set<AssetBaselineMapping>}
     * @memberof BaselineEntity
     */
    assetMappings?: Set<AssetBaselineMapping>;
    /**
     * 
     * @type {Set<BaselineAssessmentRun>}
     * @memberof BaselineEntity
     */
    assessmentRuns?: Set<BaselineAssessmentRun>;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineEntity
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const BaselineEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type BaselineEntityStatusEnum = typeof BaselineEntityStatusEnum[keyof typeof BaselineEntityStatusEnum];


/**
 * Check if a given object implements the BaselineEntity interface.
 */
export function instanceOfBaselineEntity(value: object): value is BaselineEntity {
    return true;
}

export function BaselineEntityFromJSON(json: any): BaselineEntity {
    return BaselineEntityFromJSONTyped(json, false);
}

export function BaselineEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaselineEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'baselineVersion': json['baselineVersion'] == null ? undefined : json['baselineVersion'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'oscalProfileRef': json['oscalProfileRef'] == null ? undefined : json['oscalProfileRef'],
        'oscalComponentDefRef': json['oscalComponentDefRef'] == null ? undefined : json['oscalComponentDefRef'],
        'baselineSource': json['baselineSource'] == null ? undefined : json['baselineSource'],
        'applicableAssetTypes': json['applicableAssetTypes'] == null ? undefined : json['applicableAssetTypes'],
        'applicableOsFamilies': json['applicableOsFamilies'] == null ? undefined : json['applicableOsFamilies'],
        'applicableCloudProviders': json['applicableCloudProviders'] == null ? undefined : json['applicableCloudProviders'],
        'scopeCriteria': json['scopeCriteria'] == null ? undefined : json['scopeCriteria'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'complianceLevel': json['complianceLevel'] == null ? undefined : json['complianceLevel'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'assetMappings': json['assetMappings'] == null ? undefined : (new Set((json['assetMappings'] as Array<any>).map(AssetBaselineMappingFromJSON))),
        'assessmentRuns': json['assessmentRuns'] == null ? undefined : (new Set((json['assessmentRuns'] as Array<any>).map(BaselineAssessmentRunFromJSON))),
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function BaselineEntityToJSON(json: any): BaselineEntity {
    return BaselineEntityToJSONTyped(json, false);
}

export function BaselineEntityToJSONTyped(value?: BaselineEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'baselineVersion': value['baselineVersion'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString()),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'oscalProfileRef': value['oscalProfileRef'],
        'oscalComponentDefRef': value['oscalComponentDefRef'],
        'baselineSource': value['baselineSource'],
        'applicableAssetTypes': value['applicableAssetTypes'],
        'applicableOsFamilies': value['applicableOsFamilies'],
        'applicableCloudProviders': value['applicableCloudProviders'],
        'scopeCriteria': value['scopeCriteria'],
        'framework': value['framework'],
        'complianceLevel': value['complianceLevel'],
        'isActive': value['isActive'],
        'isDefault': value['isDefault'],
        'assetMappings': value['assetMappings'] == null ? undefined : (Array.from(value['assetMappings'] as Set<any>).map(AssetBaselineMappingToJSON)),
        'assessmentRuns': value['assessmentRuns'] == null ? undefined : (Array.from(value['assessmentRuns'] as Set<any>).map(BaselineAssessmentRunToJSON)),
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

